import React from 'react'
import styled from 'styled-components'
import LoaderSpinner from '../../../../../modules/loadSpinner/LoaderSpinner'
import BrickLoader from '../../../../../modules/loadSpinner/BrickLoader'

type Props = {}

const CustomBlockLoader = () => {
  return (
    <MainWrapper>
        {/* <LoaderSpinner /> */}
        <BrickLoader />
    </MainWrapper>
  )
}
const MainWrapper = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`
export default CustomBlockLoader